import React from 'react';
import { WidgetDateTime, WidgetStatus } from '../../../../components';
import statuses from '../../../../constants/telephones/statuses';
import { useTranslation } from 'react-i18next';
import { headerSortingClasses, sortCaret } from '../../../../helpers';

export default function TelephoneColumns () {
    const { t } = useTranslation();
    return [{
        dataField: 'id',
        text: t('telephone.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'description',
        text: t('telephone.table.columns.telephone'),
        sort: false,
        classes: 'text-uppercase',
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent, row) => {
            return cellContent.slice(4);
        }
    },
    {
        dataField: 'created_at',
        text: t('telephone.table.columns.created_at'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <WidgetDateTime date={new Date(cellContent)} />
            );
        }
    }, {
        dataField: 'updated_at',
        text: t('telephone.table.columns.updated_at'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                cellContent ? <WidgetDateTime date={new Date(cellContent)} /> : null
            );
        }
    }, {
        dataField: 'active',
        text: t('telephone.table.status.title'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetStatus type={statuses[cellContent]?.type} text={`telephone.table.status.${statuses[cellContent]?.id}`} />)
    }];
}
